define('responsive-pitch-fx/lib/math/precision',['require','exports','module'],function(require,exports,module){
	return function (num) {
        return (num).toFixed(4) * 1;
    }
});
